import { UtilityService } from '@eforall/common';
import { DialogService, GridSetup } from '@eforall/dashboard';
import { VolunteerTopic } from '@interfaces';
import { DomainDataService } from '../../../../../../services';
import { VolunteerDialogDataService } from '../../volunteer-dialog-data.service';
import { getActions } from './get-actions';
import { getButtons } from './get-buttons';
import { getColumns } from './get-columns';

export function getSetup(service: VolunteerDialogDataService, util: UtilityService, dialogService: DialogService, domainData: DomainDataService): GridSetup<VolunteerTopic> {

	return {
		rowName: { singular: 'Topic', plural: 'Topics' },
		getRowKey: row => '' + row.volunteerTopicId,
		stateKey: 'volunteer-dialog-topic-grid',
		actions: getActions(service, dialogService),
		buttons: getButtons(service, dialogService),
		columns: getColumns(util, domainData),
	}
}
